import { TestimonialData } from "../components/TestimonialCard";

export const testimonials: TestimonialData[] = [
  {
    name: "Robert M.",
    location: "Lancaster, PA",
    service: "Roof Replacement",
    rating: 5,
    text: "The Graystone team did an outstanding job replacing our 20-year-old roof. They were punctual, respectful of our property, and the clean-up was immaculate. You couldn't even tell they were here, except for the beautiful new roof."
  },
  {
    name: "Sarah T.",
    location: "Lititz, PA",
    service: "Vinyl Siding",
    rating: 5,
    text: "We had Graystone replace our old aluminum siding with new vinyl siding. The transformation is incredible. The team's attention to detail around the windows and doors really shows their craftsmanship."
  },
  {
    name: "David H.",
    location: "East Petersburg, PA",
    service: "Roof Repair",
    rating: 5,
    text: "After a severe storm, we had a leak in our living room. The Graystone team came out the next day, quickly identified the issue, and patched it up. Fair pricing and honest work. Highly recommend."
  },
  {
    name: "Jennifer W.",
    location: "Manheim, PA",
    service: "Gutter Installation",
    rating: 5,
    text: "Graystone installed seamless gutters on our home. The crew was professional and finished the job in one day. We haven't had any water issues in our basement since."
  },
  {
    name: "Michael B.",
    location: "West Chester, PA",
    service: "Roof Replacement",
    rating: 5,
    text: "I appreciated the no-pressure approach during the estimate. The team explained our options clearly. The installation crew was fantastic. A truly premium service from start to finish."
  },
  {
    name: "Lisa K.",
    location: "Hershey, PA",
    service: "Metal Roofing",
    rating: 5,
    text: "We opted for a standing seam metal roof for our farmhouse. Graystone delivered beyond our expectations. It looks stunning and we've received numerous compliments from neighbors."
  },
  {
    name: "Thomas C.",
    location: "Camp Hill, PA",
    service: "Roof Inspection",
    rating: 5,
    text: "The Graystone team performed a thorough inspection of our roof before we sold our house. The report was detailed and honest, noting a few minor repairs but confirming the overall integrity of the roof."
  },
  {
    name: "Emily R.",
    location: "York, PA",
    service: "Siding & Gutters",
    rating: 5,
    text: "A complete exterior makeover! Graystone handled both our siding and gutters. The crew worked seamlessly together and the final result gave our home a brand new lease on life."
  }
];
